import dlv from "dlv";

export default function getRelationship(obj, relation, _default = []) {
  const results = dlv(obj, `relationships.${relation}.data`, null);

  return results ? results : _default;
}
